import { render } from "./basedialog.vue?vue&type=template&id=6d664f7c&scoped=true"
import script from "./basedialog.vue?vue&type=script&lang=js"
export * from "./basedialog.vue?vue&type=script&lang=js"

import "./basedialog.vue?vue&type=style&index=0&id=6d664f7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d664f7c"]])

export default __exports__